module.exports = __webpack_public_path__ + "img/stema.f310c805.jpg";